/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { TRIDENT_CAMPAIGN_TEMPLATE_TYPES } from 'constants/ucd';
import { Button } from '@duxton-web/ui';

import _ from 'lodash';
import TridentTemplateCard from 'views/ucd/trident/common/TridentTemplateCard';

type Props = {
  templateType: string,
  onTemplateSelected: Function,
  validateFormRef: Function,
  blankURL: string,
};


export class TemplateSelectionPage extends React.Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.props.validateFormRef(() => {});
  }

  render() {
    const { templateType, onTemplateSelected, blankURL } = this.props;
    return (
      <React.Fragment>
        {_.map(_.filter(TRIDENT_CAMPAIGN_TEMPLATE_TYPES, (t) => !!t.display), (template) => {
          return (<TridentTemplateCard
            isActive={templateType === template.value}
            key={template.value}
            title={template.title}
            description={template.description}
            onTemplateSelected={onTemplateSelected} templateType={template.value} icon={template.icon}
          />);
        })
        }
      <span>Or use <a href={blankURL}>Trident</a> to edit trigger and action</span>
      </React.Fragment>
    );
  }
}

export default TemplateSelectionPage;
